/**
 * Component to display languages
 */
//  Generic imports
import React from 'react';
import PropTypes from 'prop-types';

//  Motif controls
import { MotifCard, MotifCardBody } from "@ey-xd/motif-react";

const LanguageList = ({ languages }) => {
    return (
        <div>
          {languages.map((item) => (
            <MotifCard key={item.id} className="language-box-container card-spacing" role="card">
              <MotifCardBody className="cardbody">
                {item.language}
              </MotifCardBody>
            </MotifCard>
          ))}
        </div>
      );
}

LanguageList.propTypes = {
  languages: PropTypes.array
};

export default LanguageList;